import { css } from 'emotion'

export const flexCenterStyles = css`
  display: flex;
  align-items: center;
`
